var _linearGradient, _path, _linearGradient2, _path2, _radialGradient, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _radialGradient2, _path6, _linearGradient5, _path7, _linearGradient6, _path8, _linearGradient7, _path9, _linearGradient8, _path10, _linearGradient9, _path11, _linearGradient10, _path12, _linearGradient11, _path13, _linearGradient12, _path14, _path15, _linearGradient13, _path16, _linearGradient14, _path17, _linearGradient15, _path18, _linearGradient16, _path19, _linearGradient17, _path20, _radialGradient3, _circle, _linearGradient18, _circle2, _linearGradient19, _circle3, _linearGradient20, _circle4, _radialGradient4, _path21, _linearGradient21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRocketWithColor = function SvgRocketWithColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWa",
    x1: 13.954,
    x2: 21.965,
    y1: 30.687,
    y2: 35.153,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b71d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#264774"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWa)",
    d: "M20.467 19.052c-1.592.377-3.243.136-4.949-.707-3.009 1.792-5.54 3.964-7.748 6.394l7.747 3.505z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWb",
    x1: 29.537,
    x2: 38.043,
    y1: 32.945,
    y2: 29.515,
    gradientTransform: "scale(-1 1)rotate(-45 9 106.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b71d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264774"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWb)",
    d: "M28.952 27.536c-.377 1.592-.136 3.243.707 4.949-1.792 3.009-3.964 5.54-6.394 7.748l-3.505-7.747z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWc",
    cx: 26.765,
    cy: 20.517,
    r: 15.992,
    gradientTransform: "matrix(.6804 .7329 -2.6254 2.4374 66.197 -45.252)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWc)",
    d: "M41.066 7.782a.96.96 0 0 0-.845-.845c-4.848-.549-11.38-.23-15.421 5.133L13.452 27.593l6.958 6.958 15.523-11.347c5.363-4.041 5.682-10.573 5.133-15.422"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWd",
    x1: 18.438,
    x2: 25.466,
    y1: 35.855,
    y2: 35.912,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b71d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264774"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWd)",
    d: "m19.053 36.022-7.071-7.071 2.121-.707L19.76 33.9z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWe",
    x1: 21.902,
    x2: 21.834,
    y1: 38.285,
    y2: 47.954,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51e25"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWe)",
    d: "m17.259 34.223-3.478-3.478s-3.892-.011-5.731 3.293c.957.049.766.763-.214 1.603-.573.492-.928 1.403-.93 2.216.952-.277.713 1.581.095 3.145 1.564-.618 3.423-.857 3.145.095.814-.003 1.721-.36 2.213-.933.84-.979 1.557-1.168 1.606-.21 3.305-1.839 3.294-5.731 3.294-5.731"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWf",
    cx: 21.945,
    cy: 37.248,
    r: 9.096,
    gradientTransform: "rotate(45.001 33.751 31.042)scale(1 1.2072)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e51f25"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWf)",
    d: "m16.992 33.956-2.944-2.944c-.936.088-3.546.969-5.205 2.971.517.316.365 1.119-.028 1.596-.317.384-1.229.965-1.584 2.084.768-.151 1.058.857.366 2.745 1.888-.692 2.896-.402 2.745.366 1.119-.355 1.7-1.267 2.084-1.584.477-.394 1.281-.545 1.596-.028 2.002-1.66 2.882-4.27 2.97-5.206"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWg",
    x1: 22.524,
    x2: 21.365,
    y1: 32.412,
    y2: 48.326,
    gradientTransform: "rotate(46.717 23.591 27.646)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e51f25"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWg)",
    d: "M14.4 33.571c-1.712 2.272-3.97 2.14-5.959 5.973 2.407-2.8 4.987-2.665 5.959-5.973"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWh",
    x1: 24.574,
    x2: 23.754,
    y1: 35.699,
    y2: 46.96,
    gradientTransform: "matrix(.7174 .6967 -.8119 .836 29.893 -13.915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e51f25"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWh)",
    d: "M10.87 39.948c1.462-3.3 3.253-2.354 5.009-4.775-1.114 3.38-3.114 3.082-5.009 4.775"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWi",
    x1: 21.928,
    x2: 21.337,
    y1: 35.886,
    y2: 44.002,
    gradientTransform: "matrix(.969 .9374 -.9598 .9921 29.654 -25.434)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#e51f25"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWi)",
    d: "M10.997 35.686c.83-2.135 2.042-1.657 3.108-3.194-.594 2.201-1.916 2.146-3.108 3.194"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWj",
    x1: 22.953,
    x2: 22.45,
    y1: 38.736,
    y2: 45.636,
    gradientTransform: "matrix(.7656 1.1098 -1.1363 .7838 42.552 -20.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#e51f25"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWj)",
    d: "M8.28 40.255c1.037-1.72 1.935-1.095 3.061-2.253-.859 1.819-1.918 1.543-3.061 2.253"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWk",
    x1: 25.498,
    x2: 25.047,
    y1: 39.306,
    y2: 45.51,
    gradientTransform: "matrix(-.9692 -1.2218 -1.0815 .8578 80.487 30.673)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#e51f25"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWk)",
    d: "M7.683 38.442c1.724-.395 1.372-1.487 2.625-2.167-1.772.186-1.76 1.311-2.625 2.167"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWl",
    x1: 27.104,
    x2: 26.555,
    y1: 35.365,
    y2: 42.897,
    gradientTransform: "matrix(-1.0373 -.8612 -.8818 1.0621 76.835 16.854)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#e51f25"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWl)",
    d: "M13.483 36.588c1.93-.972 1.354-2.021 2.696-3.145-2.019.766-1.83 1.958-2.696 3.145"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWm",
    x1: 24.645,
    x2: 23.832,
    y1: 35.245,
    y2: 46.405,
    gradientTransform: "matrix(-.6743 -.7385 -.933 .8519 65.127 17.391)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#ffda4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#ff7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e51f25"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWm)",
    d: "M8.134 36.827c3.275-1.446 2.812-3.157 5.262-4.88-3.328 1.111-3.503 3.029-5.262 4.88"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWn",
    x1: 21.311,
    x2: 22.311,
    y1: 32.285,
    y2: 32.285,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#264774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264774"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWn)",
    d: "m15.536 33.079-.708-.707 7.072-7.071.707.707z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#288bd7",
    d: "m23.558 23.641.707.707-1.659 1.66-.707-.708z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWo",
    x1: 18.089,
    x2: 25.664,
    y1: 4.507,
    y2: 4.507,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#e62228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#8e2809"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWo)",
    d: "M40.522 16.479c.876-2.951.841-6.07.544-8.697a.96.96 0 0 0-.845-.845c-2.626-.297-5.746-.332-8.697.544z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWp",
    x1: 14.567,
    x2: 29.191,
    y1: 9.838,
    y2: 9.838,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWp)",
    d: "M39.837 18.32 29.683 8.166c-.113.051-.227.097-.338.152l10.341 10.341c.054-.112.1-.226.151-.339"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWq",
    x1: 14.69,
    x2: 29.067,
    y1: 9.515,
    y2: 9.515,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWq)",
    d: "m39.979 18.004-9.98-9.98q-.17.073-.338.152l10.166 10.166q.078-.167.152-.338"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWr",
    x1: 15.175,
    x2: 28.582,
    y1: 23.578,
    y2: 23.578,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWr)",
    d: "m29.785 27.698-9.48-9.479-.207.283 9.404 9.403z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWs",
    x1: 15.125,
    x2: 28.632,
    y1: 23.254,
    y2: 23.254,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWs)",
    d: "m30.049 27.505-9.551-9.551-.207.283 9.475 9.475z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWt",
    cx: 22.767,
    cy: 17.138,
    r: 5.887,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#020202",
    stopOpacity: 0.491
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090909",
    stopOpacity: 0.373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#151515",
    stopOpacity: 0.288
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#262626",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#3c3c3c",
    stopOpacity: 0.158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#585858",
    stopOpacity: 0.105
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#797979",
    stopOpacity: 0.057
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#9e9e9e",
    stopOpacity: 0.014
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#ababab",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.069,
    cy: 19.191,
    r: 6.169,
    fill: "url(#0fNVDNBGs8zFiB7cDozbWt)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWu",
    x1: 17.155,
    x2: 27.634,
    y1: 16.879,
    y2: 16.879,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.659,
    cy: 18.344,
    r: 5.455,
    fill: "url(#0fNVDNBGs8zFiB7cDozbWu)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWv",
    x1: 26.518,
    x2: 17.956,
    y1: 16.833,
    y2: 16.917,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaa"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.659,
    cy: 18.344,
    r: 4.457,
    fill: "url(#0fNVDNBGs8zFiB7cDozbWv)"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWw",
    x1: 17.879,
    x2: 25.879,
    y1: 16.879,
    y2: 16.879,
    gradientTransform: "rotate(45.001 24 27.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0b71d9"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.659,
    cy: 18.344,
    r: 4,
    fill: "url(#0fNVDNBGs8zFiB7cDozbWw)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWx",
    cx: 36.084,
    cy: -5.535,
    r: 4.264,
    gradientTransform: "rotate(-44.998 61.71 39.148)scale(1.4829 .283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#fff",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWx)",
    d: "M30.428 14.886c.237.237-1.402.537-2.556 1.691s-1.386 2.725-1.623 2.488-.643-1.902.796-3.341c1.282-1.282 3.147-1.075 3.383-.838"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0fNVDNBGs8zFiB7cDozbWy",
    x1: 25.679,
    x2: 45.194,
    y1: 0.664,
    y2: 15.059,
    gradientTransform: "translate(-.15 -.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0fNVDNBGs8zFiB7cDozbWy)",
    d: "M33.62 9.577c1.656-.745 3.595-1.354 5.875-1.68 0 0-3.324-.866-7.277.279z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRocketWithColor);
export default ForwardRef;